module.exports = __webpack_public_path__ + "img/banescard.0c069586.svg";